import 'rc-slider/assets/index.css';
import './StyleEditor.css';

import React, { useState } from 'react';

import { Form } from 'semantic-ui-react';
import NumberInput from 'semantic-ui-react-numberinput';
import Slider from 'rc-slider';

import ColorPicker from './ColorPicker';


const StyleEditor = ({ configuration, onSaveMapProperties }) => {

    const [unsavedCoverRanges, setCoverRanges] = useState(configuration ? configuration.cover_ranges : null);
    const [unsavedMapOptions, setMapOptions] = useState(configuration ? configuration.map_options : null);

    const createSliderWithTooltip = Slider.createSliderWithTooltip;
    const Range = createSliderWithTooltip(Slider.Range);
    const maxVal = 120;

    const defaultCoverRanges = [
        {
            interval: [-65, 0],
            color: {
                r: 0, g: 255, b: 0
            }
        },
        {
            interval: [-75, -65],
            color: {
                r: 255, g: 255, b: 0
            }
        },
        {
            interval: [-85, -75],
            color: {
                r: 255, g: 120, b: 0
            }
        },
        {
            interval: [-100, -85],
            color: {
                r: 255, g: 0, b: 0
            }
        }
    ]

    const defaultMapOptions = {
        sites: {
            color: {
                r: 0, g: 0, b: 255, a: 1
            },
            display_labels: true,
        },
        processes: {
            opacity: 70
        }
    }

    const createCoverRanges = (num) => {

        // 6 class ramps from blue to red
        const colorsRamp = [
            [3, 2, 252],
            [42, 0, 213],
            [99, 0, 158],
            [161, 1, 93],
            [216, 0, 39],
            [254, 0, 2],
        ]
        let currentTick = 0;
        const delta = maxVal / num;

        const updatedCoverRanges = [];

        for (let i = 0; i < num; i++) {
            const cr = {
                interval: [
                    -parseInt(currentTick + delta),
                    -parseInt(currentTick)
                ],
                color: {
                    r: colorsRamp[i][0],
                    g: colorsRamp[i][1],
                    b: colorsRamp[i][2]
                }
            }
            currentTick += delta;
            updatedCoverRanges.push(cr);
        }
        setCoverRanges(updatedCoverRanges);
    }


    const changeClassesNumber = (num) => {
        createCoverRanges(num);
    }

    const restoreDefaults = () => {
        setCoverRanges(defaultCoverRanges);
        setMapOptions(defaultMapOptions);
    }

    const saveMapConfiguration = () => {
        onSaveMapProperties(unsavedCoverRanges, unsavedMapOptions);
    }

    //const handleColorChange = (name) => (color) => {
    const handleColorChange = (color, name) => {
        let interval_id = name.split('_')[2];
        let updatedCoverRanges = [...unsavedCoverRanges];
        updatedCoverRanges[interval_id]["color"] = color.rgb;
        setCoverRanges(updatedCoverRanges);
        console.log('handleColorChange')
    }

    const handleColorSitesChange = (color) => {
        let updatedMapOptions = { ...unsavedMapOptions };
        updatedMapOptions.sites.color = color.rgb;
        setMapOptions(updatedMapOptions);
    }

    const handleProcessOpacityChange = (e, { value }) => {
        let updatedMapOptions = { ...unsavedMapOptions };
        updatedMapOptions.processes.opacity = parseInt(value);
        setMapOptions(updatedMapOptions);
    };

    const handleDisplayLabels = () => {
        let updatedMapOptions = { ...unsavedMapOptions };
        updatedMapOptions.sites.display_labels = document.getElementById('display_labels').checked;
        setMapOptions(updatedMapOptions);
    }

    const getRangeIntervals = () => {
        const rangeIntervals = [0];
        unsavedCoverRanges.forEach(cr => {
            rangeIntervals.unshift(cr.interval[0]);
        })
        return rangeIntervals;
    }

    const handleChangeInterval = () => (intervals) => {
        const intervalsReversed = intervals.reverse();
        let updatedCoverRanges = [...unsavedCoverRanges];
        for (let i = 0; i < updatedCoverRanges.length; i++) {
            updatedCoverRanges[i].interval = [intervalsReversed[i + 1], intervalsReversed[i]]
        }
        setCoverRanges(updatedCoverRanges);
    }

    return (
        <div>

            <button className="ui icon button"
                onClick={restoreDefaults}
                data-tooltip="Restore default classes range setting"
                data-inverted=""
            >
                <i aria-hidden="true" className="factory icon"></i>
            </button>
            <button className="ui icon button"
                onClick={saveMapConfiguration}
                data-tooltip="Save current range setting"
                data-inverted=""
            >
                <i aria-hidden="true" className="save icon"></i>
            </button>

            <div className="ui segment">

                <label>Color Ranges (dB)</label>

                <Form >
                    <Form.Group inline>
                        <label>Number of range classes</label>
                        <NumberInput
                            id="classes_number"
                            className="number-input"
                            minValue={1}
                            maxValue={6}
                            value={unsavedCoverRanges.length.toString()}
                            onChange={changeClassesNumber}
                        />
                    </Form.Group>

                    <Range
                        className='range-intervals-selector'
                        count={unsavedCoverRanges.length}
                        defaultValue={getRangeIntervals()}
                        min={-maxVal}
                        max={0}
                        pushable
                        onAfterChange={handleChangeInterval()}
                        reverse
                    />

                    <div className='color-range-selector-area'>
                        {unsavedCoverRanges.map((range, index) => (
                            <div key={`range_${index}`} >

                                <ColorPicker
                                    id={`range_color_${index}`}
                                    name={`range_color_${index}`}
                                    key={`range_color_${index}`}
                                    label={`${range.interval[1]}/${range.interval[0]} dB`}
                                    initColor={range.color}
                                    onChangeColor={handleColorChange}
                                />


                            </div>
                        ))}
                    </div>

                </Form>
            </div>

            <div className="ui segment">

                <label>Other Map Properties</label>
                <Form>
                    <Form.Group inline>

                        <ColorPicker
                            label="Sites color"
                            initColor={{ r: unsavedMapOptions.sites.color.r, g: unsavedMapOptions.sites.color.g, b: unsavedMapOptions.sites.color.b, a: unsavedMapOptions.sites.color.a }}
                            onChangeColor={handleColorSitesChange}
                        />

                    </Form.Group>

                    <Form.Input
                        className="map-opacity-slider"
                        label={`Opacity: ${unsavedMapOptions.processes.opacity}%  `}
                        min={0}
                        max={100}
                        name="opacity"
                        onChange={handleProcessOpacityChange}
                        step={1}
                        type="range"
                        value={unsavedMapOptions.processes.opacity}
                        data-tooltip="Change opacity for output cover maps (100% for trasparent)"
                        data-inverted=""
                        data-position="top center"
                    />

                    <Form.Field>
                        <label>Display site name labels</label>
                        <input
                            id="display_labels"
                            type="checkbox"
                            defaultChecked={unsavedMapOptions.sites.display_labels}
                            onChange={handleDisplayLabels}
                        />
                    </Form.Field>

                </Form>
            </div>

        </div>
    )

}

export default StyleEditor;